/**
 * @file DashboardDetailList.jsx
 * @author Daniel Aguirre
 * @description Dashboard Detail Management View Page
 */

// Dependencies
import AppCardLayout from 'components/AppCardLayout';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ManagementViewGenerator from 'components/ManagementViewGenerator';

// Helpers
import { Pagination } from 'antd';
import { PAGE_LIMIT } from '../helper/utils';

function DashboardDetailList({
  columns,
  rowData,
  totalItems,
  onPaginationChange,
  additionalColumns = [],
  onChange = () => {},
  filter,
  sorter
}) {
  const [rowDataState, setRowDataState] = useState([]);
  const [pageSize, setPageSize] = useState(PAGE_LIMIT);

  useEffect(() => {
    const adapter = rowData.map((item) => {
      return {
        ...item,
        tfg_ckd_epi2009_fecha: item?.tfg_ckd_epi2009_fecha,
        fecha_estadio: item?.fecha_estadio
      };
    });
    setRowDataState(adapter);
  }, [rowData]);

  useEffect(() => {
    onPaginationChange(1, pageSize);
  }, [filter, sorter]);

  return (
    <AppCardLayout>
      <div className="pb-4">
        <ManagementViewGenerator
          columns={[...columns, ...additionalColumns]}
          data={rowDataState}
          tableHeader={false}
          hasRowSelection={false}
          onChange={onChange}
        />
        <div className="w-full mt-4 text-center">
          {totalItems > 0 && rowData.length > 0 && (
            <Pagination
              onChange={onPaginationChange}
              showSizeChanger={true}
              pageSizeOptions={['10', '20', '50', '100', '500', '1000']}
              onShowSizeChange={(current, size) => {
                if (size !== pageSize) setPageSize(size);

                onPaginationChange(current, size);
              }}
              hideOnSinglePage
              defaultCurrent={1}
              total={totalItems}
            />
          )}
        </div>
      </div>
    </AppCardLayout>
  );
}

/**
 * Component definition of proptypes.
 */
DashboardDetailList.propTypes = {
  columns: PropTypes.array.isRequired,
  rowData: PropTypes.array.isRequired,
  totalItems: PropTypes.any.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
  additionalColumns: PropTypes.array,
  onChange: PropTypes.func,
  filter: PropTypes.object,
  sorter: PropTypes.string
};

export default DashboardDetailList;
